var initialLoad = true;
var searchTimeout = null;

$(window).bind('load', function () {
    if ($('#js-all-clinics').length > 0) {
        $('.clinic .name').matchHeight();

        $.ajaxSetup({
            cache: true
        });
        $.getScript("//maps.google.com/maps/api/js?key=AIzaSyBgGGnejKEvX2-X-BZlC0yvowTJAGCpnzU&callback=initMap");
    }
});

/**
 * Google Maps Locations
 */
window.googleMapLocations = [];

var nearestClinics = $('#js-nearest-clinics');
var nearestClinicsKey = $('#js-nearest-clinics-key');
var nearestClinicsHolder = nearestClinics.find('.clinics-list');
var allClinics = $('#js-all-clinics .clinic');
var addressField = $('#address');

allClinics.each(function () {
    window.googleMapLocations.push({
        id: $(this).attr('id'),
        location: $(this).data('location'),
        clinic: $(this).data('clinic'),
        highlighted: false,
        latitude: parseFloat($(this).data('lat')),
        longitude: parseFloat($(this).data('lng')),
        mapLocation: $(this).data('island'),
        visitingclinic: $(this).data('visitingclinic')
    });
});

/**
 * Share location on local clinics page
 */
shareLocationButton = $('.js-share-location-button');
shareLocationButton.on('click', function () {
    clearTimeout(searchTimeout);
    nearestClinics.addClass('hidden');
    nearestClinicsKey.addClass('hidden');
    nearestClinicsHolder.html('');

    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (position) {
            setClosestLocations(position.coords.latitude, position.coords.longitude)
        });
    }
});

window.activeMarkers = [];
window.southIslandMap = null;
window.northIslandMap = null;
window.fullCountryMap = null;
window.locationSearchResults = null;

locationSearchForm = $('.js-location-search');
window.locationSearchResultsHolder = locationSearchForm.find('div.results');

locationSearchForm.on('submit', function (e) {
    e.preventDefault();

    clearTimeout(searchTimeout);

    var geocoder = new google.maps.Geocoder();
    var address = addressField.val();

    nearestClinics.addClass('hidden');
    nearestClinicsKey.addClass('hidden');
    nearestClinicsHolder.html('');

    if (address != '') {
        var countryRestrict = {
            country: "NZ"
        };
        if (isNumeric(address)) {
            var countryRestrict = {
                country: "NZ",
                postalCode: address
            };
        }

        geocoder.geocode({
            address: address,
            componentRestrictions: countryRestrict
        }, function (results, status) {
            window.locationSearchResultsHolder.html('');

            if (status == google.maps.GeocoderStatus.OK) {

                if (results.length > 1) {
                    window.locationSearchResults = results;

                    for (r = 0; r < results.length; r++) {
                        result = $('<a>').attr('href', '').data('index', r).text(results[r].formatted_address);
                        result.on('click', function (e) {
                            e.preventDefault();

                            var index = $(this).data('index');

                            var position = results[index].geometry.location;
                            setClosestLocations(position.lat(), position.lng());

                            window.locationSearchResultsHolder.html('');
                        });
                        window.locationSearchResultsHolder.append(result)
                    }
                } else {
                    var position = results[0].geometry.location;
                    setClosestLocations(position.lat(), position.lng())
                }
            } else {
                window.locationSearchResultsHolder.append($('<span>').text('Address or postcode not found'));
                //alert('Geocode was not successful for the following reason: ' + status);
            }
        });
    }
});

/**
 * @param googleMapLocations
 */
function initMap(googleMapLocations = [], closestBounds = false) {

    var bounds = [];

    if (window.mobileortablet == 0) {
        bounds['north'] = new google.maps.LatLngBounds();
        bounds['south'] = new google.maps.LatLngBounds();
    } else {
        bounds['full'] = new google.maps.LatLngBounds();
    }

    /**
     * We only want to create the maps the first time the page loads, every time we find
     * our closest location
     */

    if (googleMapLocations.length === 0) {
        if (window.mobileortablet == 0) {
            this.northIslandMap = new google.maps.Map(document.getElementById('js-north-island-map'), {
                zoom: 6,
                center: {
                    lat: -39.2378,
                    lng: 175.6024
                }
            });

            this.southIslandMap = new google.maps.Map(document.getElementById('js-south-island-map'), {
                zoom: 6,
                center: {
                    lat: -45.1527,
                    lng: 169.8926
                }
            });
        } else {
            this.fullCountryMap = new google.maps.Map(document.getElementById('js-full-country-map'), {
                zoom: 4,
                center: {
                    lat: -40.9006,
                    lng: 174.8860
                }
            });
        }
    }

    var locationsArray = (googleMapLocations.length === 0) ? window.googleMapLocations : googleMapLocations;

    locationsArray.forEach(function (location) {

        var position = new google.maps.LatLng(location.latitude, location.longitude);
        var islandMap;
        if (window.mobileortablet == 0) {
            bounds[location.mapLocation].extend(position);
            islandMap = (location.mapLocation === 'south') ? window.southIslandMap : window.northIslandMap;
        } else {
            bounds['full'].extend(position);
            islandMap = window.fullCountryMap;
        }

        var markerOptions = {
            map: islandMap,
            position: position,
            id: location.id,
            title: location.clinic + ': ' + location.location,
            highlighted: location.highlighted,
            animation: google.maps.Animation.DROP,
            icon: {
                url: '/resources/themes/nzhearing/build/images/' + (location.highlighted ? 'black-ear-pin.png' : (location.visitingclinic == 1 ? 'grey-ear-pin.png' : 'green-ear-pin.png')),
                scaledSize: new google.maps.Size(50, 50)
            }
        };

        var marker = new google.maps.Marker(markerOptions);
        google.maps.event.addListener(marker, 'click', function () {
            var cid = this.id + (this.highlighted ? 'highlighted' : '');
            $('#' + cid).addClass('clinic--active');

            window.scrollToId(cid);

            setTimeout(function () {
                $('#' + cid).removeClass('clinic--active');
            }, 5000);
        });

        window.activeMarkers.push(marker);
    });

    if (closestBounds) {
        bounds = closestBounds;
    }

    if (window.mobileortablet == 0) {
        if (!bounds['north'].isEmpty()) {
            this.northIslandMap.fitBounds(bounds['north']);
        }
        if (!bounds['south'].isEmpty()) {
            this.southIslandMap.fitBounds(bounds['south']);
        }
    } else {
        if (!bounds['full'].isEmpty()) {
            this.fullCountryMap.fitBounds(bounds['full']);
        }
    }


    if (addressField.val() != '' && initialLoad) {
        searchTimeout = setTimeout(function () {
            locationSearchForm.submit();
        }, 2000);
    }

    initialLoad = false;
}

function setClosestLocations(lat, lng) {
    var closestBounds = [];
    if (window.mobileortablet == 0) {
        closestBounds['north'] = new google.maps.LatLngBounds();
        closestBounds['south'] = new google.maps.LatLngBounds();
    } else {
        closestBounds['full'] = new google.maps.LatLngBounds();
    }

    var closestLocations = ClosestLocations(
        lat,
        lng,
        this.googleMapLocations.slice(0),
        3
    );

    nearestClinics.removeClass('hidden');
    nearestClinicsKey.removeClass('hidden');

    var locationResults = this.googleMapLocations.slice(0);

    locationResults.forEach(function (location) {
        location.highlighted = false;
        closestLocations.forEach(function (closestLocation) {
            if (location.id === closestLocation.id) {
                location.highlighted = true;

                var position = new google.maps.LatLng(closestLocation.latitude, closestLocation.longitude);

                if (window.mobileortablet == 0) {
                    closestBounds[location.mapLocation].extend(position);
                } else {
                    closestBounds['full'].extend(position);
                }

                nearestClinicsHolder.append($('#' + location.id).clone().prop('id', location.id + 'highlighted'));

                nearestClinicsHolder.find('.clinic .name').matchHeight();
            }
        });
    });

    if (this.activeMarkers.length > 0) {
        this.activeMarkers.forEach(function (activeMarker) {
            activeMarker.setMap(null);
        });
    }

    initMap(locationResults, closestBounds);

    window.scrollToId('js-maps');
}

function isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}

window.initMap = initMap;
